import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { setSearch } from "../../store/reducers/frasesRespuesta/frasesRespuesta.reducer";
import { useState, useEffect } from "react";

const FrasesRespuestaHeader = () => {
  const dispatch = useDispatch();
  const { search } = useSelector((state) => state.frasesRespuesta);
  const [localSearch, setLocalSearch] = useState(search);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSearch(localSearch));
    }, 500);

    return () => clearTimeout(timer);
  }, [localSearch, dispatch]);

  return (
    <div className="d-flex flex-wrap align-items-center gap-3 justify-content-between mb-24">
      <h6 className="text-xl mb-0 flex-grow-1">Listado de frases respuesta</h6>

      <div className="position-relative flex-grow-1" style={{ maxWidth: "400px" }}>
        <Icon
          icon="mdi:magnify"
          width="20"
          className="position-absolute top-50 translate-middle-y ms-3 text-secondary-light"
        />
        <input
          type="text"
          className="form-control ps-5 h-40 radius-8"
          placeholder="Buscar por frase..."
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
        />
        {localSearch && (
          <button
            type="button"
            className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2 p-0"
            onClick={() => setLocalSearch("")}
            style={{ width: "24px", height: "24px" }}
            title="Limpiar búsqueda"
          >
            <Icon icon="mdi:close" width="18" className="text-secondary-light" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FrasesRespuestaHeader;
